import React, { useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";
import CustomerProfile from "../pages/customerPprofile/CustomerProfile";
import CustomerMasterLayout from "../layout/CustomerMasterLayout";
import VehicleInfo from "../pages/customerPprofile/VehicleInfo";
import Request from "../pages/customerPprofile/Request";
import SelectedServiceHeader from "../pages/customerPprofile/SelectedServiceHeader";
import Appointment from "../pages/customerPprofile/Appointment";
import HomePage from "../pages/customerPprofile/UpdatedUi/HomePage";
import { Modal } from "@mui/material";
import WorkshopLocator from "../pages/customerPprofile/WorkshopLocator";
import CustomerInfoModal from "../pages/customerPprofile/UpdatedUi/CustomerInfoModal";
import VehicleModal from "../pages/customerPprofile/VehicleModal";
import axios from "axios";
import ThankyouPage from "../pages/customerPprofile/UpdatedUi/ThankyouPage";
import VehicleTable from "../pages/customerPprofile/VehicleTable";
import ModalSteps from "../pages/customerPprofile/ModalSteps";
import CarServiceBooking from "../pages/customerPprofile/BookingSection";

const CustomerPrivateRoutes = ({
  setWorkshopId,
  currentStep,
  setIsCheckoutClicked,
  homeApiData,
  setCurrentStep,
  workshopId,
  storeGeoLocationData,
  setStoreGeoLocationData,
  setLiftingSlot,
}) => {
  const [liftingName, setLiftingName] = useState("");
  const [services, setServices] = useState([]);
  const [activeServiceId, setActiveServiceId] = useState(null);
  const [storeVehicleInfo, setStoreVehicleInfo] = useState({});
  const [isWorkshopSelectorClicked, setIsWorkshopSelectorClicked] =
    useState(false);
  const [openVehicleModal, setOpenVehicleModal] = useState(false);
  const [openModal, setOpenModal] = useState("");
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [vehicleData, setVehicleData] = useState([]);
  const [isOtpVerified, setIsOtpVerified] = useState(false);
  const [workshopData, setWorkshopData] = useState({});

  const fetchingTenant = window.location.hostname.split(".")[0];
  const apiPort = process.env.REACT_APP_API_PROTOCOL;
  const token = localStorage.getItem("customer-token");

  const fetchVehicle = async () => {
    try {
      const response = await axios.get(
        `${apiPort}://${fetchingTenant}.${process.env.REACT_APP_BASE_URL}/v1/gc/vehicles/`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setVehicleData(response?.data?.data);
    } catch (error) {
      console.error("Error fetching vehicles:", error);
    }
  };

  useEffect(() => {
    fetchVehicle();
    // Also allow fetching when OTP verifies
  }, [isOtpVerified]);

  const onClose = () => {
    setOpenVehicleModal(false);
    setOpenModal("");
  };

  return (
    <>
      <Routes>
        <Route
          element={
            <CustomerMasterLayout
              liftingName={liftingName}
              setStoreGeoLocationData={setStoreGeoLocationData}
              storedGeoLoaction={storeGeoLocationData}
              setStoreVehicleInfo={setStoreVehicleInfo}
              storeVehicleInfo={storeVehicleInfo}
              setOpenVehicleModal={setOpenVehicleModal}
              setOpenModal={setOpenModal}
              setIsWorkshopSelectorClicked={setIsWorkshopSelectorClicked}
              setIsCartOpen={setIsCartOpen}
              vehicleData={vehicleData}
              setCurrentStep={setCurrentStep}
              homeApiData={homeApiData}
            />
          }
        >
          <Route path="customer/profile" element={<CustomerProfile />} />
          <Route
            path="customer/thank-you"
            element={<ThankyouPage setIsCartOpen={setIsCartOpen} />}
          />
          <Route path="customer/vehicle-info" element={<VehicleInfo />} />
          <Route
            path="/vehicle/*"
            element={
              <ModalSteps
                setWorkshopData={setWorkshopData}
                workshopData={workshopData}
                checkoutServices={undefined}
                setStoreVehicleInfo={setStoreVehicleInfo}
                storeVehicleInfo={storeVehicleInfo}
                onClose={undefined}
                setWorkshopId={setWorkshopId}
                workshopId={workshopId}
                storedGeoLoaction={storeGeoLocationData}
                setLiftingSlot={setLiftingSlot}
                setIsCheckoutClicked={setIsCheckoutClicked}
                setCurrentStep={setCurrentStep}
                currentStep={currentStep}
                serviceRecord={vehicleData}
                homeApiData={homeApiData}
              />
            }
          />

          <Route
            path="/service-summary"
            element={
              <CarServiceBooking
                storeVehicleInfo={storeVehicleInfo}
                workshopData={workshopData}
                setIsCheckoutClicked={setIsCheckoutClicked}
                workshopId={workshopId}
                setCurrentStep={setCurrentStep}
                setSlotClicked={undefined}
                homeApiData={homeApiData}
              />
            }
          />

          <Route
            path="/home"
            element={
              <HomePage
                setOpenModal={setOpenModal}
                isWorkshopSelectorClicked={isWorkshopSelectorClicked}
                setIsWorkshopSelectorClicked={setIsWorkshopSelectorClicked}
                setIsCartOpen={setIsCartOpen}
                isCartOpen={isCartOpen}
                openModal={openModal}
                setOpenVehicleModal={setOpenVehicleModal}
                openVehicleModal={openVehicleModal}
                setStoreVehicleInfo={setStoreVehicleInfo}
                storeVehicleInfo={storeVehicleInfo}
                storeGeoLocationData={storeGeoLocationData}
                setVehicleData={setVehicleData}
                vehicleData={vehicleData}
                setStoreGeoLocationData={setStoreGeoLocationData}
                setIsOtpVerified={setIsOtpVerified}
                isOtpVerified={isOtpVerified}
              />
            }
          />

          <Route
            path="customer/sub-service"
            element={
              <SelectedServiceHeader
                setStoreVehicleInfo={setStoreVehicleInfo}
                storeVehicleInfo={storeVehicleInfo}
                storedGeoLoaction={storeGeoLocationData}
                services={services}
                setActiveServiceId={setActiveServiceId}
                activeServiceId={activeServiceId}
              />
            }
          />
          <Route path="customer/request" element={<Request />} />

          <Route
            path="customer/vehicle"
            element={
              <VehicleTable
                vehicleData={vehicleData}
                fetchVehicle={fetchVehicle}
                setOpenVehicleModal={setOpenVehicleModal}
              />
            }
          />

          <Route path="customer/appointments" element={<Appointment />} />
        </Route>
      </Routes>

      <Modal
        open={isWorkshopSelectorClicked}
        onClose={() => {
          setIsWorkshopSelectorClicked(false);
        }}
      >
        <WorkshopLocator
          setStoreGeoLocationData={setStoreGeoLocationData}
          storedGeoLoaction={storeGeoLocationData}
          onClose={() => setIsWorkshopSelectorClicked(false)}
        />
      </Modal>

      <CustomerInfoModal
        open={openModal === "contact"}
        onClose={() => setOpenModal("")}
      />

      {openVehicleModal && (
        <VehicleModal
          fetchVehicle={fetchVehicle}
          vehicle={undefined}
          onClose={onClose}
        />
      )}
    </>
  );
};

export default CustomerPrivateRoutes;